import { ActionTree } from 'vuex'
import { Tags } from './types'
import { RootState } from '../types'
import { TagsHelpers } from '@/helpers/mainExports.js'
import { i18n } from '@leapsight/portal'

export const actions: ActionTree<Tags, RootState> = {
  getTagsList({ commit, dispatch }, { type = '' } = {}) {
    return new Promise((resolve, reject) => {
      TagsHelpers.getTagsFind({ type })
        .then(response => {
          dispatch('setResponseError', false)
          const dataTags = response.args[0]
          if (type === 'person') {
            commit('setPersonGroups', {
              personGroups: response.args[0]
            })
            commit('resetFilterPersonGroupsState')
          } else {
            commit('setTags', {
              tags: response.args[0].filter(tag => !tag.id.includes('group'))
            })
            commit('resetFilterTagsState')
          }
          resolve(dataTags)
        })
        .catch(e => {
          dispatch('setResponseError', true)
          const response = i18n.t(
            'fleet_management.entities.entities_tab_all.errors.no_info'
          )
          dispatch('setResponseMessage', response)
          reject(e)
        })
    })
  },
  fetchTag({ dispatch, commit }, tagId) {
    return new Promise((resolve, reject) => {
      TagsHelpers.getTag(tagId)
        .then(res => {
          dispatch('setResponseError', false)
          commit('setCurrentTag', { tagData: res.args[0] })
          if (!res.code) resolve(res.args[0])
          else {
            dispatch('setResponseError', true)
            const message = i18n.t(
              'fleet_management.entities.entities_tab_all.errors.no_info'
            )
            dispatch('setResponseMessage', message)
            reject(res.message)
          }
        })
        .catch(() => {
          dispatch('setResponseError', true)
          const response = i18n.t(
            'fleet_management.entities.entities_tab_all.errors.no_info'
          )
          dispatch('setResponseMessage', response)
        })
    })
  },
  createTag({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      TagsHelpers.createTag(payload)
        .then(res => {
          dispatch('setResponseError', false)
          if (!Boolean(res.code)) {
            commit('setCurrentTag', { tagData: res.args[0] })
            resolve(res.args[0])
          } else {
            dispatch('setResponseError', true)
            const message = i18n.t(
              'fleet_management.entities.entities_tab_all.errors.no_info'
            )
            dispatch('setResponseMessage', message)
            reject(res.message)
          }
        })
        .catch(e => {
          dispatch('setResponseError', true)
          const response = i18n.t(
            'fleet_management.entities.entities_tab_all.errors.no_info'
          )
          dispatch('setResponseMessage', response)
          reject(e)
        })
    })
  },
  addEntitiesToTag({ dispatch }, { tagId, entities }) {
    return new Promise((resolve, reject) => {
      TagsHelpers.addEntitiesToTag({ tagId, entities })
        .then(res => {
          dispatch('setResponseError', false)
          if (!Boolean(res.code)) resolve(res.args[0])
          else {
            dispatch('setResponseError', true)
            const res = i18n.t(
              'fleet_management.entities.entities_tab_all.errors.no_info'
            )
            dispatch('setResponseMessage', res)
            reject(res.message)
          }
        })
        .catch(e => {
          dispatch('setResponseError', true)
          const res = i18n.t(
            'fleet_management.entities.entities_tab_all.errors.no_info'
          )
          dispatch('setResponseMessage', res)
          reject(e)
        })
    })
  },
  entitiesFind({ dispatch, commit }, { tagId, projection }) {
    return new Promise((resolve, reject) => {
      TagsHelpers.entitiesFind({ tagId, projection })
        .then(res => {
          dispatch('setResponseError', false)
          if (!Boolean(res.code)) {
            if (projection === 'thing')
              commit('setCurrentThingsToTag', {
                thingsTagData: res.args[0]
              })
            if (projection === 'agent')
              commit('setCurrentAgentsToTag', {
                agentsTagData: res.args[0]
              })
            if (projection === 'person')
              commit('setCurrentPersonsToTag', {
                personsTagData: res.args[0]
              })
            resolve({ tagId, result: res.args[0] })
          } else {
            dispatch('setResponseError', true)
            const message = i18n.t(
              'fleet_management.entities.entities_tab_all.errors.no_info'
            )
            dispatch('setResponseMessage', message)
            reject(res.message)
          }
        })
        .catch(e => {
          dispatch('setResponseError', true)
          const message = i18n.t(
            'fleet_management.entities.entities_tab_all.errors.no_info'
          )
          dispatch('setResponseMessage', message)
          reject(e)
        })
    })
  },
  setThingsTag({ dispatch }, { tagId, things }) {
    let resolve: (p: any) => void
    let reject: (p: any) => void
    const promise = new Promise((_resolve, _reject) => {
      resolve = _resolve
      reject = _reject
    })

    let thingsAdded
    let thingsRemoved

    if (things.added.length)
      thingsAdded = TagsHelpers.prepareToStoreEntitiesTagByAction({
        tagId,
        entities: things.added,
        entityType: TagsHelpers.ENTITIE_TYPE.THINGS,
        actionType: TagsHelpers.ACTION_TYPE.TAG
      })
    if (things.removed.length)
      thingsRemoved = TagsHelpers.prepareToStoreEntitiesTagByAction({
        tagId,
        entities: things.removed,
        entityType: TagsHelpers.ENTITIE_TYPE.THINGS,
        actionType: TagsHelpers.ACTION_TYPE.UNTAG
      })

    TagsHelpers.setThingsToTag({ thingsAdded, thingsRemoved })
      .then(res => {
        dispatch('setResponseError', false)
        resolve(res.args)
      })
      .catch(e => {
        dispatch('setResponseError', true)
        const response = i18n.t(
          'fleet_management.entities.entities_tab_all.errors.no_info'
        )
        dispatch('setResponseMessage', response)
        reject(e)
      })

    return promise
  },
  setAgentsTag({ dispatch }, { tagId, agents }) {
    let resolve: (p: any) => void
    let reject: (p: any) => void
    const promise = new Promise((_resolve, _reject) => {
      resolve = _resolve
      reject = _reject
    })
    let agentsAdded
    let agentsRemoved

    if (agents.added.length)
      agentsAdded = TagsHelpers.prepareToStoreEntitiesTagByAction({
        tagId,
        entities: agents.added,
        entityType: TagsHelpers.ENTITIE_TYPE.AGENTS,
        actionType: TagsHelpers.ACTION_TYPE.TAG
      })
    if (agents.removed.length)
      agentsRemoved = TagsHelpers.prepareToStoreEntitiesTagByAction({
        tagId,
        entities: agents.removed,
        entityType: TagsHelpers.ENTITIE_TYPE.AGENTS,
        actionType: TagsHelpers.ACTION_TYPE.UNTAG
      })
    TagsHelpers.setAgentsToTag({ agentsAdded, agentsRemoved })
      .then(res => {
        dispatch('setResponseError', false)
        resolve(res.args)
      })
      .catch(e => {
        dispatch('setResponseError', true)
        const response = i18n.t(
          'fleet_management.entities.entities_tab_all.errors.no_info'
        )
        dispatch('setResponseMessage', response)
        reject(e)
      })

    return promise
  },
  setPersonsTag({ dispatch }, { tagId, persons }) {
    let resolve: (p: any) => void
    let reject: (p: any) => void
    const promise = new Promise((_resolve, _reject) => {
      resolve = _resolve
      reject = _reject
    })
    let personsAdded
    let personsRemoved

    if (persons.added.length)
      personsAdded = TagsHelpers.prepareToStoreEntitiesTagByAction({
        tagId,
        entities: persons.added,
        entityType: TagsHelpers.ENTITIE_TYPE.PERSONS,
        actionType: TagsHelpers.ACTION_TYPE.TAG
      })
    if (persons.removed.length)
      personsRemoved = TagsHelpers.prepareToStoreEntitiesTagByAction({
        tagId,
        entities: persons.removed,
        entityType: TagsHelpers.ENTITIE_TYPE.PERSONS,
        actionType: TagsHelpers.ACTION_TYPE.UNTAG
      })
    TagsHelpers.setPersonsToTag({ personsAdded, personsRemoved })
      .then(res => {
        dispatch('setResponseError', false)
        resolve(res.args)
      })
      .catch(e => {
        dispatch('setResponseError', true)
        const response = i18n.t(
          'fleet_management.entities.entities_tab_all.errors.no_info'
        )
        dispatch('setResponseMessage', response)
        reject(e)
      })

    return promise
  },
  deleteTag({ dispatch, commit }, tagId) {
    TagsHelpers.deleteTag(tagId)
      .then(() => {
        dispatch('setResponseError', false)
        commit('deleteTag', tagId)
      })
      .catch(() => {
        dispatch('setResponseError', true)
        const response = i18n.t(
          'fleet_management.entities.entities_tab_all.errors.no_info'
        )
        dispatch('setResponseMessage', response)
      })
  },
  updateTag({ dispatch, commit }, { id, label, color }) {
    return new Promise((resolve, reject) => {
      TagsHelpers.updateTag({ id, label, color })
        .then(async res => {
          dispatch('setResponseError', false)
          commit('setCurrentTag', { tagData: res.args[0] })
          if (!id.includes('group')) {
            const storedTags = await TagsHelpers.getTagsFromStorage()
            const indexOfTagToUpdate = storedTags.findIndex(
              tag => tag.id === id
            )
            storedTags.splice(indexOfTagToUpdate, 1, {
              id,
              label,
              color
            })
            TagsHelpers.setTagsInLocalStorage(storedTags)
          }
          resolve(res.args[0])
        })
        .catch(e => {
          dispatch('setResponseError', true)
          const response = i18n.t(
            'fleet_management.entities.entities_tab_all.errors.no_info'
          )
          dispatch('setResponseMessage', response)
          reject(e)
        })
    })
  },
  setResponseError({ commit }, payload) {
    commit('setResponseError', payload)
  },
  setResponseMessage({ commit }, message) {
    commit('setResponseMessage', message)
  },
  cleanThingsState({ commit }) {
    commit('cleanThingsState')
  },
  filterTagsByString({ state, commit }, { string }) {
    if (string.length > 1) {
      const filterTags = state.tags.filter(
        tag =>
          tag.label.toLowerCase().match(string) ||
          tag.color.toLowerCase().match(string)
      )
      commit('setFilterTagsByString', { filterTags })
    } else commit('resetFilterTagsState')
  },
  filterPersonGroupsByString({ state, commit }, { string }) {
    if (string.length > 1) {
      const filterPersonGroups = state.personGroups.filter(
        personGroup =>
          personGroup.label.toLowerCase().match(string) ||
          personGroup.color.toLowerCase().match(string)
      )
      commit('setFilterPersonGroupsByString', { filterPersonGroups })
    } else commit('resetFilterPersonGroupsState')
  }
}
